import Vue from 'vue'
import axios from 'axios'
Vue.use(axios)
export default {
  storeContestQuiz ({dispatch}, data) {
    return new Promise ((resolve, reject) => {
      axios.post('store-daily-quiz', data)
      .then(response => {
        dispatch('GetQuizList')
        resolve(response.data)
      })
    })
  },
  GetQuizList ({commit}) {
    axios.get('get-daily-quiz-list')
    .then(response => {
      commit('setContestList', response.data)
    })
  },
  getContestDetails ({commit}, id) {
    axios.get('get-contest-details-by-admin/' + id)
    .then(response => {
      commit('setContestDetails', response.data)
    })
  }, 
  getContestQuizWinnerList ({commit}) {
    return new Promise ((resolve, reject) => {
      axios.get('get-contest-quiz-winner-list')
        .then(response => {         
          resolve(response.data)
        })
        .catch(error => {
          console.log(error)
        })
    })
  },

  uploadContestWinnerBanner ({dispatch}, data) { 
    return new Promise ((resolve, reject) => {
      axios.post('upload-winner-banner-image', data)
      .then(response => {
        resolve(response.data)
      })
    })
  },
  deleteCoverImageDailyQuiz ({dispatch}, data) {
    return new Promise ((resolve, reject) => {
      axios.post('delete-banner-image', data)
      .then(response => {
        resolve(response.data)
      })
    })
  },
  createWinnerDailyQuiz ({state, dispatch}) {
    let data =  {
      quizId: state.contestDetails.id
    }
    return new Promise ((resolve, reject) => {
      axios.post('make-winner', data)
      .then(response => {
        dispatch('getContestDetails', state.contestDetails.id)
        resolve(response.data)
      })
    })
  },
}
